<template>
    <div class="add_newAddResourse_mask"  v-if="addShow">
    <el-card class="newAdd_account">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;" >更新物流信息</span>
        </div>
        <!--<div>
            <el-radio-group v-model="myType" style="margin-bottom: 20px;" @change="changeType">
                <el-radio-button :label="0" v-if="myType==0">图片</el-radio-button>
                <el-radio-button :label="1" v-if="myType==1">视频</el-radio-button>
            </el-radio-group>
        </div>-->
        <div class="resourseContent">
            <p>
                <span class="col-lg-3">快递公司：</span><el-input class="col-lg-4" v-model="abc"></el-input>
            </p>
            <p>
                <span class="col-lg-3">快递单号：</span><el-input class="col-lg-4" v-model="bcd"></el-input><span class="col-lg-3"></span>
            </p>
            <p  v-show="false">
                <span class="col-lg-3"></span><el-input class="col-lg-4" v-model="myfxTradeIdObj"></el-input><span class="col-lg-3"></span>
            </p>

            <p style="text-align:center;"><el-button type="success" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow','fxLevelObj','fxTradeId'],
      data () {
        return {
          editfxLevelObj:{},
          abc:'',
          bcd:'',
          tradeId:''
        }
      },
      computed: {
        myfxTradeIdObj: {
          get: function () {
            console.log("after111:"+JSON.stringify(this.fxTradeId));
            this.tradeId = this.fxTradeId
            //this.editfxLevelObj.shareFee = this.fxLevelObj.shareFee/100
            return this.fxTradeId
          },
          set: function (val) {
            this.tradeId = val
          }
        },
        myfxLevelObj: {
          get: function () {
            console.log("after22:"+JSON.stringify(this.fxLevelObj));
            this.editfxLevelObj = this.fxLevelObj
            //this.editfxLevelObj.shareFee = this.fxLevelObj.shareFee/100
            return this.fxLevelObj
          },
          set: function (val) {
            console.log("after111:"+JSON.stringify(val));
            this.editfxLevelObj = val
          }
        }
      },
      created: function () {
        //this.getUpToken()
      },
      methods: {
        boxColose () {
          this.$emit('closeAddAccount', false)
        },
        commit () {
          var that = this

          console.log("abc="+this.abc)
          var params = {
            tradeId:that.tradeId,
            courierNumb:that.bcd,
            deliveryCompany:that.abc
          }
          console.log(JSON.stringify(params))
          /*if (this.expressInfo.courierNumb.trim() === ''
          || this.expressInfo.deliveryCompany.trim() === '') {
            that.$message({
              type: 'error',
              message: '快递公司或者物流单号不能为空'
            })
            return
          }*/

          var url = '/order/updateExpress'

          $ajax.post(url, params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '更新物流信息成功！'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .add_newAddResourse_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;

  .newAdd_account {
    min-height: 330px;
    width: 500px;
    top: 20%;
    left: 45%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .resourseContent {
        text-align: left;
    }
    .col-lg-3 {
        width: 20%;
        display: inline-block;
        font-weight: 400;
        color: #777;
        vertical-align: top;
    }
    .col-lg-4 {
        width: 60%;
        display: inline-block;

        textarea {
          height: 120px;
        }
    }

  }
  }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxTradeExpress.vue